export default __webpack_public_path__ + "static/media/google.b40778ce.svg";